<template>
  <v-card color="white" rounded="lg">
    <v-card-text class="pt-8 pl-6 pr-6 pb-4">
      <v-row v-if="canManage" class="ml-2 mr-2 mb-3">
        <v-col cols="12" class="tabsNh">
          <v-col cols="12" class="d-flex justify-end" style="min-height: 50px">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small class="btn-save" v-bind="attrs" v-on="on" :loading="saving" aria-label="Abrir período"
                  @click.prevent.stop="showOpenDialog = true">
                  <v-icon>mdi-lock-open-outline</v-icon>
                </v-btn>
              </template>
              <span>Abrir período</span>
            </v-tooltip>
          </v-col>
        </v-col>
      </v-row>
      <v-row class="ml-1 mb-3">
        <v-col cols="12">
          <h2>Períodos de Compras y Gastos</h2>
        </v-col>
      </v-row>
      <v-alert v-if="!canManage" type="warning" outlined dense>No tienes permiso para administrar estos
        períodos.</v-alert>



      <GeneralFilter v-if="canManage" :filter-endpoint="filterPeriods" :search="search" :col-md-search="'8'"
        :clearable="true" :hide-limit-label="true" :is-auto-scrolled="true" @emptyFilter="loadPeriods"
        @loading="loading = $event" @filtered="filterHandler">
        <template #additionalSearch>
          <v-text-field v-model.number="search.Year" type="number" label="Año" outlined dense hide-details
            class="period-year-filter" @change="loadPeriods" />
        </template>

        <DxDataGrid class="mt-5 isScrolledByGeneralFilter" :data-source="periods" key-expr="ID" :show-borders="true"
          :show-row-lines="true" :word-wrap-enabled="true" :column-auto-width="true"
          :no-data-text="'No hay períodos registrados.'" style="max-height: 600px;">
          <DxColumn caption="Acciones" cell-template="actionsTemplate" :width="180" />
          <DxColumn data-field="Year" caption="Año" :width="90" />
          <DxColumn data-field="Month" caption="Mes" cell-template="monthTemplate" :width="130" />
          <DxColumn caption="Alcance" cell-template="branchTemplate" :min-width="210" />
          <DxColumn data-field="Status" caption="Estado" cell-template="statusTemplate" :width="130" />
          <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20, 50]" />
          <DxPaging :page-size="10" />
          <template #monthTemplate="{ data }">{{ monthName(data.value) }}</template>
          <template #branchTemplate="{ data }">{{ branchName(data.data.ID_Branch) }}</template>
          <template #statusTemplate="{ data }"><v-chip small dark :color="data.value === 'OPEN' ? 'green' : 'red'">{{
            data.value === 'OPEN' ? 'Abierto' : 'Cerrado' }}</v-chip></template>
          <template #actionsTemplate="{ data }">
            <div class="period-row-actions">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }"><v-btn icon small v-bind="attrs" v-on="on"
                    aria-label="Ver historial" @click="showHistory(data.data)"><v-icon
                      color="primary">mdi-history</v-icon></v-btn></template>
                <span>Ver historial</span>
              </v-tooltip>
              <v-tooltip bottom v-if="data.data.Status === 'OPEN'">
                <template v-slot:activator="{ on, attrs }"><v-btn icon small v-bind="attrs" v-on="on" :loading="saving"
                    aria-label="Cerrar período" @click="confirmClose(data.data)"><v-icon
                      color="error">mdi-lock</v-icon></v-btn></template>
                <span>Cerrar período</span>
              </v-tooltip>
              <v-tooltip bottom v-if="data.data.Status === 'CLOSED' && canReopen">
                <template v-slot:activator="{ on, attrs }"><v-btn icon small v-bind="attrs" v-on="on" :loading="saving"
                    aria-label="Reaperturar período" @click="confirmReopen(data.data)"><v-icon
                      color="orange">mdi-lock-open-variant</v-icon></v-btn></template>
                <span>Reaperturar período</span>
              </v-tooltip>
            </div>
          </template>
        </DxDataGrid>
      </GeneralFilter>
    </v-card-text>

    <v-dialog v-model="showOpenDialog" max-width="620" persistent>
      <v-card>
        <v-card-title>Aperturar período de Compras y Gastos</v-card-title>
        <v-card-text><v-row dense>
            <v-col cols="12" sm="6"><v-text-field v-model.number="form.Year" type="number" label="Año" outlined
                dense /></v-col>
            <v-col cols="12" sm="6"><v-select v-model="form.Month" :items="months" item-text="text" item-value="value"
                label="Mes" outlined dense /></v-col>
            <v-col cols="12"><v-select v-model="form.ID_Branch" :items="branchOptions" item-text="BranchName"
                item-value="ID_Branch" label="Alcance" outlined dense /></v-col>
          </v-row></v-card-text>
        <v-card-actions class="justify-end"><v-btn text @click="showOpenDialog = false">Cancelar</v-btn><v-btn
            color="primary" :loading="saving" @click="confirmOpen">Continuar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showHistoryDialog" max-width="1000" scrollable>
      <v-card>
        <v-card-title>Historial del período</v-card-title>
        <v-card-subtitle v-if="selectedPeriod">{{ selectedPeriod.Year }} - {{ monthName(selectedPeriod.Month) }} / {{
          branchName(selectedPeriod.ID_Branch) }}</v-card-subtitle>
        <v-card-text>
          <v-progress-linear v-if="historyLoading" indeterminate color="primary" />
          <DxDataGrid v-else :data-source="history" key-expr="ID" :show-borders="true" :show-row-lines="true"
            :word-wrap-enabled="true" :column-auto-width="true" :no-data-text="'No hay movimientos registrados.'">
            <DxColumn data-field="ActionDate" caption="Fecha" />
            <DxColumn data-field="Action" caption="Acción" cell-template="historyActionTemplate" />
            <DxColumn data-field="PreviousStatus" caption="Estado anterior" cell-template="historyStatusTemplate" />
            <DxColumn data-field="NewStatus" caption="Nuevo estado" cell-template="historyStatusTemplate" />
            <DxColumn data-field="ID_User" caption="Cod. Usuario" />
            <DxColumn data-field="UserName" caption="Usuario" />
            <DxPager :show-page-size-selector="true" :allowed-page-sizes="[5, 10, 20]" />
            <DxPaging :page-size="10" />
            <template #historyActionTemplate="{ data }">{{ actionName(data.value) }}</template>
            <template #historyStatusTemplate="{ data }">{{ statusName(data.value) }}</template>
          </DxDataGrid>
        </v-card-text>
        <v-card-actions class="justify-end"><v-btn text
            @click="showHistoryDialog = false">Cerrar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <alert v-model="confirmDialog.show" :type="confirmDialog.type" :title="confirmDialog.title"
      :message="confirmDialog.message" @action="executeConfirmedOperation" />
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import GeneralFilter from '../../../components/GeneralFilter.vue';
import { DxDataGrid, DxColumn, DxPager, DxPaging } from 'devextreme-vue/data-grid';
import { hasRoleByName } from '../../../helpers/permissions';

export default {
  name: 'PurchasesExpensesPeriods',
  props: ['win'],
  components: { GeneralFilter, DxDataGrid, DxColumn, DxPager, DxPaging },
  data() {
    const currentYear = new Date().getFullYear();
    return {
      loading: false, saving: false, historyLoading: false, periods: [], history: [], branches: [],
      form: { Year: currentYear, Month: new Date().getMonth() + 1, ID_Branch: null },
      search: { ID_Business: null, Year: currentYear, filter: null },
      showOpenDialog: false, showHistoryDialog: false, selectedPeriod: null, pendingOperation: null,
      confirmDialog: { show: false, type: 'confirm', title: '', message: '' }
    };
  },
  computed: {
    ...mapState({ roles: state => (state.rolesUser && state.rolesUser.roles) || [] }),
    isAdmin() { return hasRoleByName(this.roles, ['admin', 'root', 'Administrador del sistema', 'Administrador de negocio']); },
    canManage() { return this.isAdmin || hasRoleByName(this.roles, 'AperturaCierreComprasGastos'); },
    canReopen() { return this.isAdmin || hasRoleByName(this.roles, 'ReaperturaComprasGastos'); },
    branchOptions() { return [{ ID_Branch: null, BranchName: 'Todas las sucursales' }, ...this.branches]; },
    months() { return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'].map((text, index) => ({ text, value: index + 1 })); },
    businessId() { return JSON.parse(localStorage.getItem('user') || '{}').businessid; }
  },
  mounted() { this.search.ID_Business = this.businessId; this.loadBranches(); if (this.canManage) this.loadPeriods(); },
  methods: {
    async loadBranches() { try { this.branches = await this.$API.branches.findBranches(this.businessId) || []; } catch (error) { this.branches = []; } },
    filterPeriods(params) { return this.$API.purchasesExpensesPeriods.getPeriods({ ...params, ID_Business: this.businessId, Year: params.Year || this.search.Year }); },
    async loadPeriods() { this.loading = true; try { const response = await this.filterPeriods(this.search); this.periods = response.result || []; } catch (error) { this.notifyError(error); } finally { this.loading = false; } },
    filterHandler(response) { this.periods = response.result || []; },
    operationData(period) { return { ID_Business: this.businessId, ID_Branch: period ? period.ID_Branch : this.form.ID_Branch, Year: period ? period.Year : this.form.Year, Month: period ? period.Month : this.form.Month }; },
    confirmOpen() { this.showOpenDialog = false; this.pendingOperation = { operation: 'open', data: this.operationData() }; this.confirmDialog = { show: true, type: 'confirm', title: 'Confirmar apertura', message: '¿Deseas abrir este período para Compras y Gastos?' }; },
    confirmClose(period) { this.pendingOperation = { operation: 'close', data: this.operationData(period) }; this.confirmDialog = { show: true, type: 'confirm-danger', title: 'Confirmar cierre', message: '¿Deseas cerrar este período?' }; },
    confirmReopen(period) { if (!this.canReopen) return; this.pendingOperation = { operation: 'reopen', data: this.operationData(period) }; this.confirmDialog = { show: true, type: 'confirm-danger', title: 'Confirmar reapertura', message: '¿Deseas reaperturar este período?' }; },
    async executeConfirmedOperation() { this.confirmDialog.show = false; if (!this.pendingOperation) return; const operation = this.pendingOperation; this.pendingOperation = null; await this.runOperation(operation.operation, operation.data); },
    async showHistory(period) { this.selectedPeriod = period; this.history = []; this.showHistoryDialog = true; this.historyLoading = true; const params = { ID_Business: this.businessId, Year: period.Year, Month: period.Month, ID_Branch: period.ID_Branch === null ? 'NULL' : period.ID_Branch }; try { const response = await this.$API.purchasesExpensesPeriods.getHistory(params); this.history = response.result || []; } catch (error) { this.notifyError(error); } finally { this.historyLoading = false; } },
    async runOperation(operation, data) {
      this.saving = true;
      try {
        await this.$API.purchasesExpensesPeriods[operation](data);
        this.confirmDialog = {
          show: true,
          type: 'success',
          title: 'Operación completada',
          message: 'La operación se realizó correctamente.'
        };
        await this.loadPeriods();
      } catch (error) {
        this.notifyError(error);
      } finally {
        this.saving = false;
      }
    },
    notifyError(error) {
      const message = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : (error && error.message) || 'No fue posible completar la operación.';
      this.confirmDialog = {
        show: true,
        type: 'error',
        title: 'No fue posible completar la operación',
        message
      };
    },
    monthName(month) { const item = this.months.find(monthItem => monthItem.value === Number(month)); return item ? item.text : month; },
    branchName(id) { if (id === null || id === undefined || id === '') return 'Todas las sucursales'; const branch = this.branches.find(item => String(item.ID_Branch) === String(id)); return branch ? branch.BranchName : id; },
    actionName(action) { return { OPEN: 'Apertura', CLOSE: 'Cierre', REOPEN: 'Reapertura' }[action] || action; },
    statusName(status) { return { OPEN: 'Abierto', CLOSED: 'Cerrado' }[status] || status || '-'; }
  }
};
</script>

<style scoped>
.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.period-year-filter {
  min-width: 120px;
  margin-right: 12px;
}

.period-row-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
}
</style>
